<template>
    <profile-info :errors="filledErrors" :loading="isFetching" :profile="profile" :companyFullName="companyFullName"/>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ProfileInfo from './ProfileInfo';

export default {
    name: 'company-menu-container',
    components: {
        ProfileInfo,
    },
    data() {
        return {
            isFetching: false,
        }
    },
    methods: {
        ...mapActions('profile', ['fetchProfile']),
    },
    created() {
        if (!this.isFetched) {
            this.isFetching = true;
            this.fetchProfile()
                .then((res) => {
                    this.isFetching = false;
                })
                .catch((res) => {
                    this.isFetching = false;
                });
        }
    },
    computed: {
        ...mapGetters('orgTypes', ['orgTypes', 'individualId']),
        ...mapState('profile', ['profile', 'isFetched', 'isFilled']),
        ...mapGetters('profile', ['companyFullName', 'filledErrors']),
    }
}
</script>



// WEBPACK FOOTER //
// ProfileInfoContainer.vue?d288343a